import { useTranslation } from 'react-i18next';
import {
  FieldDescription,
  FieldGroup,
  FieldLegend,
  FieldSet,
} from '@/Domain/components/Shared/Field/Field';
import { FormControl, FormField, FormItem } from '@/Domain/components/Shared/Form/Form';
import { RadioGroup, RadioGroupItem } from '@/Domain/components/Shared/RadioGroup/RadioGroup';
import { cn } from '@/Domain/utils/cn';

const EXECUTION_MODES = ['ai_decides', 'before_first_reply', 'when_metadata_matches'] as const;

export const ExecutionModeField = () => {
  const { t } = useTranslation('actions_page', { keyPrefix: 'sheet.form.execution_mode' });

  return (
    <FormField
      name="execution_mode"
      render={({ field }) => (
        <FormItem>
          <FieldSet className="space-y-1">
            {/* The collapsible section header carries the visible label. */}
            <FieldLegend variant="label" className="sr-only">
              {t('label')}
            </FieldLegend>
            <FieldDescription>{t('description')}</FieldDescription>
            <FieldGroup className="pt-3">
              <FormControl>
                <RadioGroup
                  value={field.value}
                  onValueChange={field.onChange}
                  className="grid gap-3 lg:grid-cols-3"
                  data-testid="http-request-action-execution-mode"
                >
                  {EXECUTION_MODES.map((mode) => (
                    <label
                      key={mode}
                      htmlFor={`execution-mode-${mode}`}
                      className={cn(
                        'flex cursor-pointer items-start gap-3 rounded-xl border border-border bg-card p-4 transition-colors hover:bg-accent',
                        field.value === mode && 'border-foreground',
                      )}
                    >
                      <RadioGroupItem
                        id={`execution-mode-${mode}`}
                        value={mode}
                        className="mt-0.5"
                        data-testid={`execution-mode-${mode}`}
                      />
                      <span className="flex flex-col gap-1">
                        <span className="block text-sm font-medium text-foreground">
                          {t(`${mode}.label`)}
                        </span>
                        <span className="block text-sm text-muted-foreground">
                          {t(`${mode}.description`)}
                        </span>
                      </span>
                    </label>
                  ))}
                </RadioGroup>
              </FormControl>
            </FieldGroup>
          </FieldSet>
        </FormItem>
      )}
    />
  );
};
